export default [
    {
        "title": "Reporting Issues - who?",
        "description": "Since many of our users use the app from a single account we have added a new name feild when reporting an issue, this allows admins to be able to check with the original reporter of the issue if needed.",
        "image": "fa fa-warning"
    },
    {
        "title": "Reporting Issues - evidence",
        "description": "When reporting an issue from the app you can now optionally include a photo to allow better recording of issues",
        "image": "fa fa-warning"
    },
    {
        "title": "Reports",
        "description": "We had added some new reports as CSV downloads for you to make viewing and manipulating your data easier",
        "image": "fa fa-chart-bar"
    },
    {
        "title": "Faster checks",
        "description": "We have redesigned the temperature input on the app to make it quicker and easier to choose the right value. We have also added auto-next when you choose an option on the checkbox task which improves the overall speed and efficiency of completing checks.",
        "image": "fa fa-check"
    },
    {
        "title": "Minor Fixes & Improvements",
        "description": "Thanks to all our users who have reported issues and suggested improvements. We've made a number of minor fixes and improvements to make CheckMate better for everyone.",
        "image": "fa fa-wrench"
    }
]